import React, { useState } from 'react';
import { FaFilePdf, FaFileExcel, FaFileCsv } from 'react-icons/fa';

const ExportOptions = ({ onExport }) => {
  const [isExporting, setIsExporting] = useState(false);
  
  const handleExport = async (format) => {
    try {
      setIsExporting(true);
      await onExport(format);
    } catch (error) {
      console.error(`Error exporting to ${format}:`, error);
    } finally {
      setIsExporting(false);
    }
  };
  
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm font-medium text-gray-700 mr-2">Export as:</span>
      
      <button
        onClick={() => handleExport('pdf')}
        disabled={isExporting}
        className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 cursor-pointer"
      >
        <FaFilePdf className="text-red-500 mr-2" />
        PDF
      </button>
      
      <button
        onClick={() => handleExport('excel')}
        disabled={isExporting}
        className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 cursor-pointer"
      >
        <FaFileExcel className="text-green-600 mr-2" />
        Excel
      </button>
      
      <button
        onClick={() => handleExport('csv')}
        disabled={isExporting}
        className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 cursor-pointer"
      >
        <FaFileCsv className="text-blue-500 mr-2" />
        CSV
      </button>
      
      {isExporting && (
        <span className="ml-2 text-sm text-gray-600">Preparing export...</span>
      )}
    </div>
  );
};

export default ExportOptions;